<script setup lang="ts">
import type { TtLocationFragment } from '#graphql-operations'

const props = defineProps<{
  store: TtLocationFragment
}>()

const OAwidget = computed(() => {
  let oawidget = `<div
      id="oa_widget"
      class="widget-js"
    /><`
  oawidget += `script type="text/javascript" src="${props.store.pickupUrl?.replace('output/html', 'output/js')}"></`
  oawidget += `script>`
  return oawidget
})
</script>

<template>
  <LazyUiDialog
    v-if="store?.pickupUrl"
    name="store-pickup-dialog"
    dialog-type="responsive"
  >
    <template #dialogHeader>
      <span class="dialog__title">{{ $t('Book your collection appointment') }}</span>
    </template>

    <UiEmbedFramed :embed-code="OAwidget" />

    <!--
    
    -->
  </LazyUiDialog>
</template>

<style>
@import url("~layers/components/Store/AdviceDialog.css");
</style>
